<script setup>
    import { reactive, onMounted, watch } from 'vue'
    import { ref as databaseRef, onValue, query } from "firebase/database";
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"

    const database = Firebase.database;
    const reactiveObj = reactive({
        //企業コード
        corporateId: '',
        //企業情報
        corporateInfo : {},
    })
    //企業情報の取得（リアルタイムで変更を検知したいのでutilsではなく関数はここに記載）
    const getCorporateInfo = async (corporateId) => {
        const settingsRef = databaseRef(database, `CorporateId/${corporateId}/CorporateInfo`)
        onValue(settingsRef, (snapshot) => {
            reactiveObj.corporateInfo = snapshot.val() ? snapshot.val() : undefined;
        })
    }
    onMounted(async () => {
        reactiveObj.corporateId = await utilFunctions.getCorporateId()
        await getCorporateInfo(reactiveObj.corporateId)
    })
</script>
<template>
    <div class="header_container">
        <p id="corporateName"></p>
    </div>
    <div id="rollBackDisplay" v-show="reactiveObj.corporateInfo.RollBackFlag">
        <p>
            現在処理中のため、操作できません。<br>
            完了までしばらくお待ちください。
        </p>
    </div>
</template>

<style scoped>
    @import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;700&display=swap");
    @import url("https://fonts.googleapis.com/icon?family=Material+Icons");
    header {
        background-color: #e7e6e6;
        width: auto;
    }
    .header_container {
        display: flex;
        justify-content: space-between;
        padding: 30px 0 0 50px;
        height: 40px;
        width: auto;
        background-color: #e7e6e6;
    }
    .header_container p {
        font-size: 35px;
        padding: 0 0 0 10px;
    }
    #rollBackDisplay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        /* 背景色（黒、不透明度80%） */
        background-color: #000000;
        opacity: 0.8;
        /* フレックスコンテナ（縦並べ、横中央、縦中央） */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* 表示を一番上 */
        z-index: 998;
        /* 選択付加 */
        user-select: none;
        p {
            color: #FFFFFF;
            font-size: 20px;
        }
    }
</style>